import React from "react";
import UnitCountThree from "./child/UnitCountThree";
import Balances3 from "./child/Balances3";
import BalanceLimit3 from "./child/BalanceLimit3";
import TradingFrequency3 from "./child/Tradingfrequency3";
const DashBoardLayerThree = () => {
  return (
    <>
      
      <section>
        <div className="row gy-4 mt-4">
          <Balances3 />
          {/* <BalanceLimit3 />
          <TradingFrequency3 /> */}
        </div>
      </section>
    </>
  );
};

export default DashBoardLayerThree;
